export default __webpack_public_path__ + "components/bike-park-header/static/background--3-87f8d7c8b97c2dae2bd39056f6943ac5.jpg";